import { z } from "zod";

export type DBSchemaType = z.infer<typeof DBSchema>;
export type DBMaterialType = z.infer<typeof DBMaterial>;


export const DBMaterial = z.object({
    code: z.string().min(1),
    name: z.string(),
    description: z.string(),
    // measurements_unit: z.string(),
    graining: z.boolean(),
    // color: z.string(),
    thickness: z.number(),
    type: z.number().int(),
    //     """1=płyta; 2=dłużyca; 3=obrzeże; 4=Inne materiały i dobra; 5=Serwis i operacje"""
    sheets: z.array(
        z.object({
            length: z.number(),
            width: z.number(),
            // sell_price: z.number(),
        })
    )
}).strict();
export const DBSchema = z.object({
    materials: z.array(
        DBMaterial
    )
}).strict();

